import lb from '@/lib/loopback';


export function findIdiomas(settings = {}) {
  return lb
    .find('/IdiomasPubs/', settings);
}

export default {
  findIdiomas,
};
